<template>
  <ScrollContainer>
    <div class="home-hero">
      <div class="home-bg"></div>
      <div class="home-content">
        <h1 class="home-title">九任智造 · 赋能未来</h1>
        <p class="home-subtitle">创新驱动，智领高端，助力企业数字化转型</p>

        <div class="box-bg">
          <div class="modern-slider">
            <div class="slider-container" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
              <div v-for="(item, index) in topNewsList" :key="item.id" class="slide"
                :class="{ 'active': currentSlide === index }">
                <div class="slide-bg" :style="{
                  backgroundImage: `url(${image_path}${item.cover})`
                }"></div>
                <div class="slide-content">
                  <div class="slide-info">
                    <button class="slide-news-btn" @click="router.push('/news')">新闻资讯</button>
                    <h1 class="slide-title">{{ item.title }}</h1>
                    <a class="slide-btn" :href="`/news/${item._id}`">了解详情</a>
                  </div>
                </div>
              </div>
            </div>
            <!-- 左右箭头 -->
            <div class="slider-arrow left" @click="prevSlide">
              <ArrowLeft />
            </div>
            <div class="slider-arrow right" @click="nextSlide">
              <ArrowRight />
            </div>
          </div>
        </div>

        <div class="box-bg" ref="mediaSection">
          <div class="medis-mess-box">
            <div class="mod-con">
              <div class="t-flx">
                <div class="label-box">
                  <h3 style="cursor:pointer" @click="router.push('/media')">视频媒体</h3>
                </div>
              </div>
              <div class="media-tab">
                <ul class="ul">
                  <li v-for="(tab, idx) in mediaTabs" :key="tab.label" :class="{ 'active-li': mediaTabIndex === idx }"
                    @click="selectMediaTab(idx)">
                    <em class="line"></em>
                    <p class="label">{{ tab.label }}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="con-tab-box">
              <div class="mod-con">
                <!-- 视频资料 -->
                <div v-show="mediaTabIndex === 0" class="con-tab">
                  <div class="list-box">
                    <div class="list" v-for="item in videolist" :key="item.link" :data-url="item.link"
                      @click="openVideo(item.link)">
                      <a>
                        <div class="pic-box"
                          :style="`background: url('${image_path}${item.cover}') center center no-repeat; background-size: cover`">
                          <img class="down-icon" src="@/assets/home/play-icon.png" alt="img" />
                        </div>
                        <p class="label">{{ item.introduction }}</p>
                      </a>
                    </div>
                    <div class="list more-last-list c-r-m">
                      <a @click="router.push('/media')">
                        <div class="pic-box">
                          <img class="pic" src="@/assets/1.webp" alt="img" />
                          <div class="look-all">
                            <p class="label">查看全部</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <!-- 企业图片 -->
                <div v-show="mediaTabIndex === 1" class="con-tab ">
                  <div class="list-box">
                    <div class="list" v-for="item in imglist" :key="item.link" :data-url="item.link"
                      @click="showImagePreview(item.cover)">
                      <a>
                        <div class="pic-box"
                          :style="`background: url('${image_path}${item.cover}') center center no-repeat; background-size: cover`">
                        </div>
                        <p class="label">{{ item.introduction }}</p>
                      </a>
                    </div>
                    <div class="list more-last-list c-r-m">
                      <a @click="router.push('/media')">
                        <div class="pic-box">
                          <img class="pic" src="@/assets/1.webp" alt="img" />
                          <div class="look-all">
                            <p class="label">查看全部</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <!-- 活动图集 -->
                <div v-show="mediaTabIndex === 2" class="con-tab">
                  <div class="list-box">
                    <div class="list" v-for="item in activelist" :key="item.link" :data-url="item.link"
                      @click="showImagePreview(item.cover)">
                      <a>
                        <div class="pic-box"
                          :style="`background: url('${image_path}${item.cover}') center center no-repeat; background-size: cover`">
                        </div>
                        <p class="label">{{ item.introduction }}</p>
                      </a>
                    </div>
                    <div class="list more-last-list c-r-m">
                      <a @click="router.push('/media')">
                        <div class="pic-box">
                          <img class="pic" src="@/assets/1.webp" alt="img" />
                          <div class="look-all">
                            <p class="label">查看全部</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="box-bg" ref="topicActivitySection">
          
          <div class="mod-con">
            <div class="title">
              <p> 专题活动 </p>
            </div>
            
            <div class="list-box">
              
              <div class="list" v-for="item in topicActivityList" :key="item.id">
                <a>
                  <div class="pic-box"
                    :style="`background: url('${image_path}${item.cover}') center center no-repeat; background-size: cover`">
                  </div>
                  <p class="label">{{ item.title }}</p>
                </a>
              </div>
            </div>
          </div>
        </div> -->

        <div class="box-bg" ref="brandStorySection">
          <!-- 品牌故事内容 -->
          <div class="mod-con brand-story-container">
            <div class="brand-story-text-section">
              <div class="title brand-story-title">
                <p> 品牌故事 </p>
              </div>
              <!-- 品牌故事详细内容 -->
              <div class="brand-story-description">
                {{ brandStoryContent.description }}
              </div>
              <a :href="brandStoryContent.link" class="brand-story-button">了解更多 >></a>

              <div class="brand-story-stats">
                <div class="stat-item" v-for="(stat, index) in brandStoryContent.stats" :key="index">
                  <div class="stat-number">{{ stat.number }}</div>
                  <div class="stat-label">{{ stat.label }}</div>
                </div>
              </div>
            </div>
            <div class="brand-story-image-section">
              <img src="@/assets/about/home_2.jpg" alt="品牌故事图片" class="brand-story-image" />
            </div>
          </div>
        </div>

        <div class="box-bg" ref="achievementsSection">
          <!-- 成果与荣誉内容 -->
          <div class="container">
            <h2 class="a-title font42 color-2 text-center wow fadeInDown">成果与荣耀</h2>
            <div class="HPC3-top wow fadeInUp">
              <ul class="HPC3-tab list-style flex justify-center font18 color-2 text-center">
                <li :class="{ active: achievementsTabIndex === 0 }" @click="selectAchievementsTab(0)"><span>成果资质</span>
                </li>
                <li :class="{ active: achievementsTabIndex === 1 }" @click="selectAchievementsTab(1)"><span>获奖荣誉</span>
                </li>
                <div class="HPC3-tab-mask"></div>
              </ul>
            </div>
            <div class="HPC3-bot font18 wow fadeInUp">
              <div class="a4-item a4-item1" v-show="achievementsTabIndex === 0">
                <div class="a4-swiper a4-swiper1 text-center">
                  <div class="swiper-container">
                    <div class="swiper-wrapper">
                      <!-- 遍历认证与资质列表 -->
                      <div class="swiper-slide" v-for="item in achievementList" :key="item.id">
                        <a class="HPC5-link" href="#">
                          <div class="HPC5-img base-img">
                            <div class="img-bg">
                              <img :src="image_path + item.cover" :alt="item.title">
                            </div>
                          </div>
                          <div class="HPC5-text font22">
                            <div class="HPC5-con MultiLine">
                              <div class="HPC5-des">
                                <p v-html="item.introduction"></p>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <span class="a-prev a4-prev font24"><i class="iconfont icon-xiangzuojiantou"></i></span>
                  <span class="a-next a4-next font24"><i class="iconfont icon-xiangyoujiantou"></i></span>
                </div>
              </div>
              <div class="a4-item a4-item2" v-show="achievementsTabIndex === 1">
                <div class="a4-swiper a4-swiper2 text-center">
                  <div class="swiper-container">
                    <div class="swiper-wrapper">
                      <!-- 遍历获奖荣誉列表 -->
                      <div class="swiper-slide" v-for="item in honorList" :key="item.id">
                        <a class="HPC5-link" href="#">
                          <div class="HPC5-img base-img">
                            <div class="img-bg">
                              <img :src="image_path + item.cover" :alt="item.title">
                            </div>
                          </div>
                          <div class="HPC5-text font22">
                            <div class="HPC5-con MultiLine">
                              <div class="HPC5-des">
                                <p v-html="item.introduction"></p>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <span class="a-prev a4-prev font24"><i class="iconfont icon-xiangzuojiantou"></i></span>
                  <span class="a-next a4-next font24"><i class="iconfont icon-xiangyoujiantou"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="box-bg" ref="casesSection">

          <div class="mod-con">
            <div class="title">
              <p> 案例分享 </p>
            </div>
          </div>
        </div> -->

      </div>
    </div>

    <!-- Add image preview modal here -->
    <div v-if="showPreview" class="image-preview-modal" @click="closeImagePreview">
      <img :src="previewImageUrl" alt="Image Preview" class="image-preview-content" />
    </div>

    <Footer />

  </ScrollContainer>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Footer from '../views/Footer.vue'
import ScrollContainer from '../components/ScrollContainer.vue'
import { onMounted, ref, computed, onUnmounted, onBeforeUnmount, nextTick } from 'vue'
import axios from 'axios'
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue'
import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'

const router = useRouter()
const navList = ref([])
const newsList = ref([])
const config = require('../../../config')
const image_path = config[config.mode].image_path
const videolist = ref([])
const imglist = ref([])
const activelist = ref([])

const mediaSection = ref(null) // Declare the ref
const topicActivitySection = ref(null); // New ref
const brandStorySection = ref(null); // New ref
const achievementsSection = ref(null); // New ref
const casesSection = ref(null); // New ref

let observer = null; // To store the observer instance (consider using an array/map for multiple observers)

// New reactive data variables
const topicActivityList = ref([]);
const brandStoryContent = ref({}); // Assuming brand story is a single piece of content
const achievementsList = ref([]);
const casesList = ref([]);

// New reactive variables for image preview
const showPreview = ref(false);
const previewImageUrl = ref('');

const sections = computed(() => {
  if (navList.value.length > 0 && navList.value[0].children) {
    return navList.value[0].children.map(item => ({
      title: item.name,
      desc: '', // 如需描述可补充
      path: item.link ? (item.link.startsWith('/') ? item.link : '/' + item.link) : undefined
    }))
  }
  return []
})
let timer = null

// 启动自动播放
const startAutoPlay = () => {
  stopAutoPlay(); // 先清除旧的定时器
  timer = setInterval(() => {
    nextSlide();
  }, 5000); // 5秒切换一次
};

// 停止自动播放
const stopAutoPlay = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
};

// Variables to store Swiper instances
let certificationsSwiperInstance = null; // To store Swiper instance
let awardsSwiperInstance = null; // To store Swiper instance
let casesSwiperInstance = null; // To store Swiper instance

onMounted(async () => {
  await nextTick()
  await fetchNewsList()
  startAutoPlay()

  // Set up IntersectionObserver for the media section
  const mediaObserver = new IntersectionObserver((entries) => { // Rename observer for clarity
    const entry = entries[0];
    if (entry.isIntersecting) {
      getVideo();
      getImg();
      getActive();
      mediaObserver.disconnect(); // Disconnect this observer
    }
  }, { threshold: 0.1 });

  if (mediaSection.value) {
    mediaObserver.observe(mediaSection.value);
  }

  // Set up IntersectionObserver for Topic Activity section
  const topicActivityObserver = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      getTopicActivity();
      topicActivityObserver.disconnect();
    }
  }, { threshold: 0.1 });

  if (topicActivitySection.value) {
    topicActivityObserver.observe(topicActivitySection.value);
  }

  // Set up IntersectionObserver for Brand Story section
  const brandStoryObserver = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      getBrandStory();
      brandStoryObserver.disconnect();
    }
  }, { threshold: 0.1 });

  if (brandStorySection.value) {
    brandStoryObserver.observe(brandStorySection.value);
  }

  // Set up IntersectionObserver for Achievements section
  const achievementsObserver = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      getAchievements(); // Fetch data
      nextTick(() => {
        // Initialize Swiper for both tabs when data is loaded, they will be updated on tab click
        certificationsSwiperInstance = initSwiper('.a4-swiper1', achievementList.value.length);
        awardsSwiperInstance = initSwiper('.a4-swiper2', honorList.value.length);
      });
      achievementsObserver.disconnect();
    }
  }, { threshold: 0.1 });

  if (achievementsSection.value) {
    achievementsObserver.observe(achievementsSection.value);
  }

  // Set up IntersectionObserver for Cases section
  const casesObserver = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      getCases(); // Fetch data
      nextTick(() => { // Wait for DOM update after data is set
        casesSwiperInstance = initSwiper('.cases-swiper'); // Initialize Cases Swiper
      });
      casesObserver.disconnect();
    }
  }, { threshold: 0.1 });

  if (casesSection.value) {
    casesObserver.observe(casesSection.value);
  }
})

onBeforeUnmount(() => {
  stopAutoPlay()
  // Destroy Swiper instances on component unmount
  if (certificationsSwiperInstance) certificationsSwiperInstance.destroy(true, true);
  if (awardsSwiperInstance) awardsSwiperInstance.destroy(true, true);
  if (casesSwiperInstance) casesSwiperInstance.destroy(true, true);

  // Disconnect all observers
  // This part needs manual disconnection for each named observer if not stored in an array/map
  // For now, relying on the disconnect within the observer callback.
  // A more robust approach for multiple observers is recommended for production.
})

const fetchNewsList = async () => {
  var res = await axios.get("/webapi/news/list")
  newsList.value = res.data.data
}
const topNewsList = computed(() => newsList.value.slice(0, 4))

const fetchNavList = () => {
  axios.get('/webapi/navbar/list').then(function (response) {
    if (response.data && response.data.ActionType === 'OK') {
      navList.value = response.data.data || []
    }
  }).catch(error => {
    console.error('获取导航栏数据失败:', error)
  })
}

function goToSection(item) {
  if (item.path) router.push(item.path)
}

const currentSlide = ref(0)
function prevSlide() {
  currentSlide.value = (currentSlide.value - 1 + newsList.value.length) % newsList.value.length
}
function nextSlide() {
  currentSlide.value = (currentSlide.value + 1) % newsList.value.length
}

const mediaTabIndex = ref(0)
const mediaTabs = [
  { label: '视频资料', icon: '/img/media/icon-2.png' },
  { label: '企业图片', icon: '/img/media/icon-3.png' },
  { label: '活动图集', icon: '/img/media/icon-4.png' }
]
function selectMediaTab(idx) {
  mediaTabIndex.value = idx
}

const getVideo = () => {
  axios.get('/webapi/image/list', {
    params: {
      keyword: 'media_video'
    }
  }).then(function (response) {
    if (response.data && response.data.data) {
      videolist.value = response.data.data.slice(0, 7)
    }
  }).catch(function (error) {
    console.error('获取视频列表失败:', error)
  })
}

const getImg = () => {
  axios.get('/webapi/image/list', {
    params: {
      keyword: 'media_img'
    }
  }).then(function (response) {
    if (response.data && response.data.data) {
      imglist.value = response.data.data.slice(0, 7)
    }
  }).catch(function (error) {
    console.error('获取图片列表失败:', error)
  })
}

const getActive = () => {
  axios.get('/webapi/image/list', {
    params: {
      keyword: 'media_active'
    }
  }).then(function (response) {
    if (response.data && response.data.data) {
      activelist.value = response.data.data.slice(0, 7)
    }
  }).catch(function (error) {
    console.error('获取图片列表失败:', error)
  })
}

function openVideo(url) {
  window.open(url, '_blank')
}

// Placeholder data fetching functions for new sections
const getTopicActivity = () => {
  console.log('Fetching topic activity data...');
  // Replace with actual API call when available
  // axios.get('/webapi/image/list', { params: { keyword: 'topic_activity' } }).then(...)
  // For now, set some dummy data
  topicActivityList.value = [
    { id: 1, cover: '/path/to/topic_activity1.jpg', title: '活动一' },
    { id: 2, cover: '/path/to/topic_activity2.jpg', title: '活动二' },
    // Add more dummy data or replace with real data fetching logic
  ];
};

const getBrandStory = () => {
  console.log('Fetching brand story data...');
  // Replace with actual API call when available
  // axios.get('/webapi/brandstory').then(...) // Example endpoint
  // For now, set some dummy data
  brandStoryContent.value = {
    description: '这是我们的品牌故事的详细内容...',
    link: '/introduction',
    imageUrl: '/path/to/brand_story.jpg',
    stats: [
      { number: '10+', label: '年经验' },
      { number: '50+', label: '成功案例' },
      { number: '95%', label: '客户满意度' }
    ]
  };
};

const getAchievements = () => {
  axios.get('/webapi/image/list', {
    params: {
      keyword: 'achievement'
    }
  }).then(function (response) {
    if (response.data && response.data.data) {
      achievementList.value = response.data.data
    }
  }).catch(function (error) {
    console.error('获取图片列表失败:', error)
  })

  axios.get('/webapi/image/list', {
    params: {
      keyword: 'honor'
    }
  }).then(function (response) {
    if (response.data && response.data.data) {
      honorList.value = response.data.data
    }
  }).catch(function (error) {
    console.error('获取图片列表失败:', error)
  })
}

function showImagePreview(cover) {
  previewImageUrl.value = image_path + cover; // Use image_path to construct the full URL
  showPreview.value = true;
}

// Function to close image preview
function closeImagePreview() {
  showPreview.value = false;
  previewImageUrl.value = ''; // Clear the URL when closing
}

const achievementsTabIndex = ref(0)
const achievementList = ref([])
const honorList = ref([])

function selectAchievementsTab(idx) {
  achievementsTabIndex.value = idx;
  nextTick(() => {
    if (idx === 0) {
      if (certificationsSwiperInstance) {
        certificationsSwiperInstance.destroy(true, true);
      }
      certificationsSwiperInstance = initSwiper('.a4-swiper1', achievementList.value.length);
    } else {
      if (awardsSwiperInstance) {
        awardsSwiperInstance.destroy(true, true);
      }
      awardsSwiperInstance = initSwiper('.a4-swiper2', honorList.value.length);
    }
  });
}

function initSwiper(selector, listLength = 0) {
  const swiperElement = document.querySelector(selector + ' .swiper-container');
  if (!swiperElement) {
    console.warn(`Swiper container not found for selector: ${selector}`);
    return null;
  }

  if (swiperElement.swiper) {
    swiperElement.swiper.destroy(true, true);
  }

  // 计算当前屏幕下 slidesPerView
  let slidesPerView = 3;
  if (window.innerWidth < 768) {
    slidesPerView = 1;
  } else if (window.innerWidth < 1024) {
    slidesPerView = 2;
  }

  // 数据量不足时不启用 loop
  const enableLoop = listLength > slidesPerView;

  const swiperInstance = new Swiper(selector + ' .swiper-container', {
    modules: [Navigation, Autoplay],
    slidesPerView,
    spaceBetween: 30,
    loop: enableLoop,
    navigation: {
      nextEl: selector + ' .a-next',
      prevEl: selector + ' .a-prev',
    },
    breakpoints: {
      320: { slidesPerView: 1, spaceBetween: 10 },
      768: { slidesPerView: 2, spaceBetween: 20 },
      1024: { slidesPerView: 3, spaceBetween: 30 }
    },
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  });

  return swiperInstance;
}

// Updated data fetching function for Cases
const getCases = () => {
  console.log('Fetching cases data...');
  // Replace with actual API call when available
  // axios.get('/webapi/image/list', { params: { keyword: 'cases' } }).then(response => {
  //   if (response.data && response.data.data) {
  //     casesList.value = response.data.data; // Assuming cases are a flat list
  //   }
  // }).catch(error => {
  //   console.error('获取案例展示数据失败:', error);
  // });

  // Dummy data updated
  casesList.value = [
    { id: 1, cover: '/path/to/case1.jpg', title: '案例一标题' },
    { id: 2, cover: '/path/to/case2.jpg', title: '案例二标题' },
    { id: 3, cover: '/path/to/case3.jpg', title: '案例三标题' },
    { id: 4, cover: '/path/to/case4.jpg', title: '案例四标题' },
    { id: 5, cover: '/path/to/case5.jpg', title: '案例五标题' },
    // Add more dummy cases
  ];
};
</script>

<style lang="scss" scoped>
.home-hero {
  margin-top: 80px;
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .home-bg {
    position: absolute;
    inset: 0;
    background: linear-gradient(120deg, #233d9c 0%, #4055a8 50%, #e9ecf7 100%);
    opacity: 0.95;
    z-index: 0;
  }

  .home-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 1800px;
    margin: 0 auto;
    padding: 60px 20px 40px 20px;
    text-align: center;

    .home-title {
      font-size: 48px;
      color: #fff;
      font-weight: 700;
      letter-spacing: 2px;
      margin-bottom: 16px;
      text-shadow: 0 4px 24px rgba(35, 61, 156, 0.18);
    }

    .home-subtitle {
      font-size: 22px;
      color: #e9ecf7;
      margin-bottom: 48px;
      font-weight: 400;
      letter-spacing: 1px;
    }
  }
}

.box-bg {
  min-height: 0;
  padding: 20px 0;
  position: relative;
}

.modern-slider {
  overflow: hidden;
  height: 700px;
  background: #000;

  .slider-container {
    display: flex;
    height: 100%;
    transition: transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .slide {
    min-width: 1800px;
    height: 100%;
    position: relative;

    .slide-bg {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      filter: brightness(0.7);
    }

    .slide-content {
      position: absolute;
      left: 20%;
      top: 50%;
      transform: translateY(-50%);
      width: auto;
      height: auto;
      display: flex;
      align-items: center;
      pointer-events: none;

      .slide-info {
        pointer-events: auto;
        max-width: 700px;
        color: #fff;
        text-align: left;
        margin-bottom: 0;

        .slide-news-btn {
          background: none;
          min-width: 150px;
          min-height: 50px;
          border: 1px solid #FFFFFF;
          border-radius: 10px;
          padding: 0 10px;
          font: inherit;
          cursor: pointer;
          outline: inherit;
          text-align: center;
          color: #fff;
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 18px;
          transition: background 0.5s, border 0.5s;

          &:hover {
            background: #233d9c;
            border: none;
          }
        }

        .slide-title {
          font-size: 38px;
          font-weight: 600;
          margin-bottom: 18px;
          line-height: 1.1;
        }

        .slide-btn {
          color: #fff;
          font-size: 20px;
          font-weight: 500;
          cursor: pointer;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
        }

        .slide-btn::after {
          content: ' >';
          font-size: 24px;
          margin-left: 6px;
        }
      }
    }
  }

  .slider-controls {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 0 60px 18px 60px;
    display: flex;
    align-items: flex-end;
    z-index: 2;

    .slider-dots {
      display: flex;
      width: 100%;
      gap: 20px;
      justify-content: flex-start;

      .dot-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        min-width: 0;

        .dot-line {
          position: relative;
          height: 0.125vw;
          width: 100%;
          background: rgba(255, 255, 255, 0.3);
          margin-bottom: 4px;
          cursor: pointer;
          transition: background 0.2s, height 0.2s;
          overflow: hidden;

          .dot-progress {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background: #fff;
            z-index: 2;
            pointer-events: none;
            width: 100%;
            animation: progressBar 5s linear;
          }
        }

        .dot-label {
          color: #fff;
          font-size: 1.145833vw;
          opacity: 0.8;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 90%;
        }
      }
    }
  }

  .slider-arrow {
    position: absolute;
    top: 50%;
    z-index: 10;
    width: 48px;
    background: transparent;
    color: #b3c6e0;
    font-size: 36px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;

    &:hover {
      background: #4055a8;
      color: #fff;
    }
  }

  .slider-arrow.left {
    left: 24px;
  }

  .slider-arrow.right {
    right: 24px;
  }
}

.medis-mess-box {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 32px 0 rgba(35, 61, 156, 0.10);
  padding: 36px 32px 32px 32px;
  max-width: 1800px;
  min-width: 900px;
  height: 100%;
}

.medis-mess-box .label-box h3 {
  font-size: 32px;
  font-weight: 700;
  color: #233d9c;
  margin-bottom: 32px;
  letter-spacing: 2px;
  text-align: left;
}

.media-tab {
  background: transparent;
  margin: 0 0 32px 0;

  .ul {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 80px;
    padding: 0;
    margin: 0;
    list-style: none;
    border-bottom: 2px solid #e9ecf7;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding: 0 36px 0 36px;
      position: relative;
      min-width: 120px;
      background: none;

      .line {
        display: block;
        width: 100%;
        height: 4px;
        background: transparent;
        margin-bottom: 8px;
        border-radius: 2px;
        transition: background 0.3s;
      }

      img {
        width: 44px;
        height: 44px;
        margin-bottom: 8px;
      }

      .label {
        font-size: 18px;
        color: #222;
        font-weight: 400;
        margin: 0;
        letter-spacing: 1px;
      }

      &.active-li {
        .line {
          background: #233d9c;
        }

        .label {
          color: #233d9c;
          font-weight: 600;
        }

        img {
          filter: drop-shadow(0 2px 8px #233d9c33);
        }
      }
    }
  }
}

// 去除多余嵌套和无用class，优化整体结构
.t-flx,
.clearfix,
.mod-con {
  all: unset;
}

.con-tab-box {
  width: 100%;
  background: #fff;
  padding: 0 0 30px 0;

  .mod-con {
    margin: 0 auto;

    .con-tab {
      padding-top: 0;

      &.con-tab-active {
        display: block;
        box-sizing: border-box;
      }

      &.con-tab-mod {
        display: none;
        box-sizing: border-box;
      }
    }

    .list-box {
      display: flex;
      flex-wrap: wrap;
      gap: 32px 24px;
      margin-top: 0;
      justify-content: flex-start;
    }

    .list {
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 rgba(35, 61, 156, 0.08);
      overflow: hidden;
      width: calc(25% - 18px);
      min-width: 240px;
      margin-bottom: 0;
      transition: box-shadow 0.3s, transform 0.15s;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: stretch;

      &:hover {
        background: rgba(26, 59, 166, 0.85);
        color: #fff;
        box-shadow: 0 8px 32px 0 rgba(35, 61, 156, 0.18);
        transform: translateY(-4px) scale(1.03);
      }

      a {
        display: block;
        flex-direction: column;
        text-decoration: none;
      }

      .pic-box {
        width: 100%;
        aspect-ratio: 16/9;
        position: relative;
        background: #eee;
        background-size: cover !important;
        background-position: center !important;
        display: flex;
        align-items: center;
        justify-content: center;

        .pic {
          width: 100%;
        }
      }

      .down-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 48px;
        height: 48px;
      }

      .look-all {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(26, 59, 166, 0.85);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;

        .label {
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 6px;
        }

        .desc {
          font-size: 16px;
          opacity: 0.9;
        }
      }

      .label {
        font-size: 16px;
        text-align: center;
        margin: 16px 0 12px 0;
        font-weight: 400;
        min-height: 22px;

        &:hover {
          color: #fff;
        }
      }
    }

    .more-last-list {
      background: #1a3ba6;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      .pic-box {
        background: #1a3ba6 !important;
      }

      .label,
      .desc {
        color: #fff !important;
      }
    }
  }
}

/* Image Preview Styles */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; // Ensure it's on top of other content
}

.image-preview-content {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain; // Contain the image within the modal
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
}

/* Brand Story Styles (mimicking Center Introduction) */
.brand-story-container {
  display: flex;
  align-items: center; // Align items vertically
  justify-content: space-between; // Space out text and image
  padding: 40px;
  background-color: #fff;
  border-radius: 18px;
  margin-top: 40px;
}

.brand-story-text-section {
  flex: 1;
  padding-right: 40px;
  max-width: 60%;
}

.brand-story-title {
  font-size: 36px;
  font-weight: 700;
  color: #233d9c;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.brand-story-description {
  font-size: 18px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 30px;
}

.brand-story-button {
  display: inline-block;
  background-color: #435ebc;
  color: #fff;
  padding: 12px 24px;
  border-radius: 5px;
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  transition: background-color 0.3s ease;
  margin-bottom: 40px;

  &:hover {
    background-color: #1b3eb9;
  }
}

.brand-story-stats {
  display: flex;
  justify-content: center;
  gap: 60px;
}

.stat-item {
  text-align: left;
}

.stat-number {
  font-size: 36px;
  font-weight: 700;
  color: #1b3eb9;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 16px;
  color: #555;
}

.brand-story-image-section {
  flex-shrink: 0;
  width: 60%;
  margin-right: -70px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 40px 62px 0 rgba(28, 58, 167, 1);
}

.brand-story-image {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}

/* Achievements and Honors Styles */
.container {
  padding: 40px 20px;
  overflow: hidden;
}

.a-title {
  font-size: 42px;
  color: #222;
  text-align: center;
  margin-bottom: 40px;
}

.HPC3-top {
  margin-bottom: 30px;
}

.HPC3-tab {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: #555;
  border-bottom: 2px solid #eee;
  position: relative;
}

.HPC3-tab li {
  padding: 10px 20px;
  cursor: pointer;
  transition: color 0.3s ease;
  font-weight: 400;
  /* Adjust default font weight */
}

.HPC3-tab li.active {
  color: #233d9c;
  font-weight: bold;
  position: relative;
}

.HPC3-tab li.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #233d9c;
  transition: width 0.3s ease;
  /* Add transition for active indicator */
}

.HPC3-tab li:hover {
  color: #233d9c;
  /* Add hover effect */
}

.HPC3-tab-mask {
  display: none;
}

.HPC3-bot {
  /* Styles for the content area below tabs */

}

.a4-item {
  /* Container for each tab's content */
}

.a4-swiper {
  /* Swiper container styles */
  position: relative;
  padding: 0 40px;
}

.swiper-container {
  width: 100%;
  height: auto !important;
}

.swiper-slide {
  /* Styles for individual slides */
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }
}

.HPC5-link {
  display: block;
  text-decoration: none;
  color: inherit;
}

.HPC5-img {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.img-bg img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.HPC5-text {
  padding: 15px;
  text-align: center;
  font-size: 22px;
}

.HPC5-con {
  color: #353535;
  line-height: 1.6;
  height: 3.2em;
  -webkit-line-clamp: 2;
}

.MultiLine {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.HPC5-des p {
  margin: 0;
}

.a-prev,
.a-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #fff;
  }
}

.a-prev {
  left: 5px;
}

.a-next {
  right: 5px;
}

.iconfont {
  font-size: 18px;
  color: #555;
}

/* Adjustments for responsiveness if needed using breakpoints */
/* Example:
@media (max-width: 767px) {
  .a4-swiper {
    padding: 0 20px;
  }
  .a-prev, .a-next {
    width: 24px;
    height: 24px;
    font-size: 14px;
  }
}
*/
</style>